<template>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm">
        <div class="describe">
            {{ type == 1 ? "您正在使用手机验证方式找回密码" : "您正在使用邮箱验证方式修改密码" }}
        </div>
        <el-form-item :label="type == 1 ? '手机号码：' : '邮箱号码：'" prop="fieldName">
            <el-input
                v-model.trim="ruleForm.fieldName"
                :placeholder="type == 1 ? '请输入手机号码' : '请输入您的邮箱'"
                style="width:520px;margin-left:14px"
            ></el-input>
        </el-form-item>

        <el-form-item label="手机验证码：" prop="codeNumber">
            <el-input v-model.trim="ruleForm.codeNumber" placeholder="请输入验证码" style="width:300px;"></el-input>
            <el-button
                type="primary"
                style="width:200px;margin-left:14px;"
                :disabled="!flag || canSendMsg"
                @click="getCode"
            >
                <span v-if="canSendMsg">{{ countDown }}s后重新获取</span>
                <span v-else>获取验证码</span>
            </el-button>
        </el-form-item>
        <div class="but-item">
            <el-button round size="small" style="width:240px;margin-right:40px;height:44px" @click="next('back')"
                >上一步</el-button
            >
            <el-button round type="primary" size="small" style="width:240px; height:44px" @click="next"
                >下一步</el-button
            >
        </div>
    </el-form>
</template>
<script>
export default {
    props: {
        type: {
            type: Number,
            default: 0,
        },
        banckdata: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            countDown: 60,
            canSendMsg: false, //是否可以发送验证码
            ruleForm: {
                source: "PS",
                fieldName: "",
                notify: this.type == 1 ? "SMS" : "EMAIL",
                newPassword: "",
                sign: "",
                codeNumber: "",
            },
            rules: {
                fieldName: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                    {
                        pattern: /^1[3456789]\d{9}$/,
                        message: "请输入正确的手机号",
                        trigger: "blur",
                    },
                ],
                codeNumber: [{ required: true, message: "请输入验证码", trigger: "blur" }],
            },
            flag: false,
        };
    },
    computed: {
        fieldName() {
            return this.ruleForm.fieldName;
        },
    },
    watch: {
        fieldName(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.change();
            }
        },
    },
    created() {
        this.setRules();
        this.ruleForm.notify = this.type === 1 ? "SMS" : "EMAIL";
    },
    mounted() {
        if (this.ruleForm.notify === this.banckdata.notify) {
            this.ruleForm = this.banckdata;
        }
    },
    methods: {
        change() {
            let phoneReg = this.type === 1 ? /^1[23456789]\d{9}$/ : /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
            if (phoneReg.test(this.ruleForm.fieldName)) {
                this.flag = true;
            } else {
                this.flag = false;
            }
        },
        setRules() {
            if (this.type === 2) {
                this.rules.fieldName[0].message = "请输入邮箱";
                this.rules.fieldName[1].pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                this.rules.fieldName[1].message = "请输入正确的邮箱地址";
            }
        },
        next(type) {
            if (type === "back") {
                this.$emit("next", type);
                return;
            }
            // else {
            //     this.$emit("goNext", 2);
            // }
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    // this.ruleForm.codeNumber = this.ruleForm.code;
                    this.$axios
                        .post("/uc/account/verify/code", this.ruleForm)
                        .then(() => {
                            this.$emit("next", type);
                            this.$emit("savenext", this.ruleForm);
                            // this.$emit("goNext", 2);
                        })
                        .catch((err) => {
                            this.$message.error(err.data.message);
                        });
                } else {
                    return false;
                }
            });
        },

        getCode() {
            this.$axios
                .post("/uc/account/verification", this.ruleForm)
                .then(() => {
                    this.canSendMsg = true;
                    let auth_timetimer = setInterval(() => {
                        this.countDown--;
                        if (this.countDown <= 0) {
                            clearInterval(auth_timetimer);
                            this.countDown = 60;
                            this.canSendMsg = false;
                        }
                    }, 1000);
                })
                .catch((err) => {
                    this.$message.error(err.data.message);
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.describe {
    color: $primary;
    padding-left: 15px;
    margin-bottom: 32px;
    // padding-top: 52px;
}

.but-item {
    margin: 72px 0 0;
    text-align: center;
}
</style>
<style lang="scss">
.el-form {
    // width: 646px !important;
}
.input-content {
    width: 700px !important;
}

.demo-ruleForm {
    // width: 646px;
    .el-button--mini {
        width: 646px;
        height: 28px;
        line-height: 28px;
        padding: 0 !important;
        text-align: center;
    }
}
</style>
